import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react';
import DeleteClusterletTemplates from '../clusterlet_templates/DeleteClusterletTemplates'

export default function DeleteTemplateAlert(props) {
    const { onCompletion, id, onClose } = props;
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteClusterletTemplates onCompletion={onCompletion} id={id} onClose={onClose} />

        </Dialog >
    )
}